import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Input, Toast, Select } from '@douyinfe/semi-ui';
import { IconSearch } from '@douyinfe/semi-icons';
import request from '../../utils/request';
import styles from './index.module.scss';

const OpLog = () => {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10, total: 0 });
    const [searchKey, setSearchKey] = useState('');
    const [searchOperators, setSearchOperators] = useState([]);
    const [operatorList, setOperatorList] = useState([]);

    const fetchOperatorList = async () => {
        try {
            const response = await request.get('/go/spc/mlist_subsp/', {
                params: {
                    with_admin: 1,
                }
            });
            if (response.errno === 0) {
                setOperatorList(response.list || []);
            } else {
                Toast.error(response.errstr || '获取操作人列表失败');
            }
        } catch (error) {
            console.error('获取操作人列表失败:', error);
            Toast.error('获取操作人列表失败');
        }
    };

    const fetchList = async (page = 1, limit = 10) => {
        setLoading(true);
        try {
            const response = await request.get('/go/sp/sp_oplog/list_sp_oplog/', {
                params: {
                    page: page - 1,
                    limit,
                    key: searchKey,
                    subsp_uids: searchOperators.join(',')
                }
            });
            if (response.errno === 0) {
                setDataSource(response.list || []);
                setPagination(prev => ({
                    ...prev,
                    currentPage: page,
                    total: response.total_cnt
                }));
            } else {
                Toast.error(response.errstr || '获取列表失败');
            }
        } catch (error) {
            console.error('获取列表失败:', error);
            Toast.error('获取列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
        fetchOperatorList();
    }, []);

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const columns = [
        {
            title: '操作人',
            dataIndex: 'subsp',
            width: 200,
            render: (text, record) => (
                <div style={{ fontSize: '12px' }}>
                    <div style={{ color: 'var(--semi-color-text-0)', marginBottom: '4px' }}>{text?.name || '-'}</div>
                </div>
            )
        },
        {
            title: '操作内容',
            dataIndex: 'log',
            width: 300,
            render: (text) => {
                // 创建一个临时的div元素来解析HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text || '-';

                // 移除所有非<b>标签
                const sanitizeHTML = (node) => {
                    const fragment = document.createDocumentFragment();
                    Array.from(node.childNodes).forEach(child => {
                        if (child.nodeType === 3) { // 文本节点
                            fragment.appendChild(child.cloneNode());
                        } else if (child.nodeType === 1 && child.nodeName.toLowerCase() === 'b') { // <b>标签
                            const b = document.createElement('b');
                            b.appendChild(document.createTextNode(child.textContent));
                            fragment.appendChild(b);
                        } else if (child.nodeType === 1) { // 其他标签
                            fragment.appendChild(document.createTextNode(child.textContent));
                        }
                    });
                    return fragment;
                };

                const sanitizedFragment = sanitizeHTML(tempDiv);
                tempDiv.innerHTML = '';
                tempDiv.appendChild(sanitizedFragment);

                return (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: tempDiv.innerHTML
                        }}
                        className={styles.logContent}
                    />
                );
            }
        },
        {
            title: '接口信息',
            dataIndex: 'path',
            width: 250,
            render: (text, record) => (
                <div style={{ fontSize: '12px' }}>
                    <div style={{ color: 'var(--semi-color-text-0)', marginBottom: '4px' }}>{text || '-'}</div>
                    <div style={{ color: 'var(--semi-color-text-2)' }}>UA: {record.ua || '-'}</div>
                </div>
            )
        },
        {
            title: 'IP地址',
            dataIndex: 'ip',
            width: 150
        },
        {
            title: '操作时间',
            dataIndex: 'create_time',
            width: 180,
            render: (text) => formatTimestamp(text)
        }
    ];

    return (
        <div className={styles.opLogContainer}>
            <div className={styles.header}>
                <Space>
                    <Input
                        placeholder="搜索操作内容"
                        value={searchKey}
                        onChange={setSearchKey}
                        style={{ width: 200 }}
                        showClear
                    />
                    <Select
                        placeholder="选择操作人（可多选）"
                        value={searchOperators}
                        onChange={setSearchOperators}
                        style={{ width: 300 }}
                        multiple
                        maxTagCount={3}
                        showClear
                    >
                        {operatorList.map(operator => (
                            <Select.Option key={operator.uid} value={operator.uid}>{operator.name}</Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        onClick={() => fetchList(1, pagination.pageSize)}
                        loading={loading}
                        icon={<IconSearch />}
                    >
                        搜索
                    </Button>
                </Space>
            </div>

            <Table
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    currentPage: pagination.currentPage,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    onPageChange: (page) => fetchList(page, pagination.pageSize),
                    onPageSizeChange: (size) => fetchList(1, size)
                }}
                rowKey="id"
            />
        </div>
    );
};

export default OpLog;